<template>
  <div class="mt-10 text-white">
    <h2 class="flex text-white items-center uppercase text-3xl font-bold mb-8 px-6 md:px-0">
      <i
        class="bg-blue-500 rounded-full bg-white h-16 w-16 mr-4 flex items-center justify-center shadow-sm"
      >
        <img class="rounded-full object-cover" v-if="project.logo" :src="project.logo" alt />
      </i>
      <span>Items in pool</span>
    </h2>

    <div>
      <div v-if="nfts.length < 1" class="text-2xl text-center text-white">No NFTs yet</div>
      <div v-if="nfts.length >= 1" class="text-grey-900 mt-16 grid grid-cols-1 md:px-0 px-12 md:grid-cols-4 gap-4">
        <div
          class="bg-opacity-0 bg-tertiary rounded-lg p-1"
          v-for="nft in nfts"
          :key="nft.nft_id"
        >
          <GalleryItem :nft="nft" />
        </div>
      </div>
    </div>
  </div>
</template>


<script>
const axios = require("axios").default;

import GalleryItem from "@/components/GalleryItem.vue";
export default {
  name: "GalleryView",
  components: { GalleryItem },

  props: {
    pool: String,
  },
  computed: {},
  data: function() {
    return {
      nfts: []
    };
  },
  beforeMount: async function() {
    let nfts = await axios.get(
      "https://api.nft20.io/nfts?perPage=500000&page=1&pool=" + this.pool
    );
    this.nfts = nfts.data.data;
    // console.log(this.nfts);
  },
  methods: {},
  mounted: async function() {},
  computed: {
      project: function () {
      return this.$store.state.currentProject;
    }
  }
};
</script>